<template>
  <div class="row myrow" v-if="!isProjectLoading">
    <div
      class="col-xs-12 mycol header-title"
      :class="
        currentUser.ACTIVE_ROLE == 8 || currentUser.ACTIVE_ROLE == 24
          ? ''
          : 'header-title-mt-100'
      "
    >
      <div class="col-xs-12 col-sm-6 col-md-5 mycol">
        <p class="h-t-name" v-if="!title">
          Резюме проекта / {{ project.ORG_INFO.UF_NAME }}
          <span v-show="project.UF_NUMBER != ''"
          >(№{{ project.UF_NUMBER }})</span
          >
        </p>
        <div class="h-t-name" v-else>{{ title }}</div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-7 mycol">
        <div class="h-t-status">
          <div class="h-t-status-text">
            <span class="h-t-status-text-wrapper">
              <!-- <span
                >Программа: "{{
                  project.PROJECT_MAIN_INFO.UF_SUPPORT_PROG_NAME
                }}",</span
              > -->
              <span v-if="project.UF_MANAGER_NAME"
              >Менеджер проекта: "{{ project.UF_MANAGER_NAME }}",</span
              >
              <span v-if="projectStatus"
              >Статус проекта: "{{ projectStatus }}"</span
              >
            </span>
            <span
              v-if="project.UF_HELP && project.UF_HELP.STATUS_NAME"
              class="h-t-status-info info-holder-container"
            >
              <span class="info-holder-icon"></span>
              <span class="info-holder-content info-holder-content_link">
                <span class="info-holder-content__text">
                  {{ project.UF_HELP.STATUS_NAME }}
                </span>
              </span>
            </span>
          </div>
          <div class="h-t-status-buttons">
            <a
              v-if="codeType && $parent.showCalendar"
              title="Экспорт календарного плана"
              v-on:click="getPrintPlanDocxUrl"
              class="docs"
              style="padding-right: 15px;padding-bottom: 10px;"
            >
              <img src="/images/docs.png" />
            </a>

            <a
              v-if="
                currentUser.ACTIVE_ROLE_CODE === 'manager3' ||
                  currentUser.ACTIVE_ROLE_CODE === 'manager2' ||
                  currentUser.ACTIVE_ROLE_CODE === 'admin'
              "
              v-on:click="exportEAHistory()"
              title="История вынесения проектов на ЭС"
              style="padding-right: 15px;padding-bottom: 10px;"
            >
              <img src="/images/xls.png" />
            </a>
            <a
              v-if="excelOrgId"
              @click="getLinkIndicatorsByOrgExcel"
              title="Экспорт показателей компании"
              style="padding-right: 20px; padding-bottom: 10px;"
            >
              <img src="/images/xls.png" />
            </a>
            <a
              v-if="
                currentUser.ACTIVE_ROLE_CODE === 'manager3' ||
                  currentUser.ACTIVE_ROLE_CODE === 'manager2' ||
                  currentUser.ACTIVE_ROLE_CODE === 'admin'
              "
              v-on:click="loadEAHistory()"
              title="История вынесения проектов на ЭС"
              style="padding-right: 20px; padding-bottom: 10px;"
            >
              <img src="/images/ea.png" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade in show"
      v-if="showStatusHistory"
      tabindex="-1"
      role="dialog"
    >
      <div
        style="width: 1000px;z-index: 10000"
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showStatusHistory = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">История изменения статуса проекта</h4>
          </div>
          <div
            class="modal-body"
            style="
              overflow: scroll;
              max-height: 500px;
            "
          >
            <table class="table table-hover">
              <thead>
              <tr>
                <th>№</th>
                <th>Текущий статус</th>
                <th>Предыдущий статус</th>
                <th style="width: 200px">Время начала статуса</th>
                <th style="width: 200px">Время окончания статуса</th>
                <th>Примечание</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in projectStatusHistory" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ getStatusName(item.UF_CURRENT_ST_ID) }}</td>
                <td>{{ getStatusName(item.UF_PREV_ST_ID) }}</td>
                <td>{{ item.UF_START_DATE_ST }}</td>
                <td>{{ item.UF_FINISH_DATE_ST }}</td>
                <td>{{ item.DESCRIPTION }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              v-on:click="showStatusHistory = false"
            >
              Закрыть
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <div
      class="modal fade in show"
      v-if="showEAHistory"
      tabindex="-1"
      role="dialog"
    >
      <div
        style="width: 1000px;z-index: 10000"
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showEAHistory = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">История вынесения проектов на ЭС</h4>
          </div>
          <div
            class="modal-body"
            style="
    overflow: scroll;
    max-height: 500px;
"
          >
            <table class="table table-hover">
              <thead>
              <tr>
                <th>№ ЭС</th>
                <th>Дата ЭС</th>
                <th>Тип</th>
                <th style="width: 240px">Дата вынесения проекта на ЭС</th>
                <th>Комментарий</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, indexItem) in eaHists" :key="indexItem">
                <td>{{ item.UF_NUMBER }}</td>
                <td>{{ item.UF_DATE_SOVET }}</td>
                <td>{{ item.TYPE_MAKING.NAME }}</td>
                <td>{{ item.UF_DATE_CREATE }}</td>
                <td>{{ item.UF_COMMENT }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              v-on:click="showEAHistory = false"
            >
              Закрыть
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>

<script>
import { ExpertAdvice, ProjectsService } from "@/common/api.service";
import { mapGetters } from "vuex";
import { AUTH_URL } from "@/common/config";
import { FETCH_PROJECT_HISTORY } from "@/store/actions.type";
import FirstScenariosStep from "@/components/project/form/subpartial/FirstScenariosStep.vue";

export default {
  components: { FirstScenariosStep },
  name: "ProjectHeader",
  props: ["showPlanLink", "title", "excelOrgId"],
  data() {
    return {
      showStatusHistory: false,
      showEAHistory: false,
      eaHists: [],
      codeType: false
    };
  },
  computed: {
    projectStatus: function() {
      if (this.project.UF_STATUS_ID > 0) {
        let t = this.directory.status.filter(
          c => c.ID === this.project.UF_STATUS_ID
        );
        if (t.length > 0) {
          return t[0].NAME;
        }
      }
    },
    projectStatusCode: function() {
      if (this.project.UF_STATUS_ID > 0) {
        let t = this.directory.status.filter(
          c => c.ID === this.project.UF_STATUS_ID
        );
        if (t.length > 0) {
          return t[0].CODE;
        }
      }
    },
    ...mapGetters([
      "directory",
      "project",
      "currentUser",
      "isProjectLoading",
      "projectStatusHistory"
    ])
  },
  async mounted() {
    this.updateDocInfo();
    //await this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);
  },
  methods: {
    updateDocInfo() {
      ProjectsService.getDocumentESProjects(this.$route.params.id)
        .then(({ data }) => {
          if (data.LIST_TYPE.length > 0) {
            const TYPE_LIST_ID = data.LIST_TYPE[0].TYPE_LIST_ID;
            let A = false;
            TYPE_LIST_ID.forEach(el => {
              el.CODE_TYPE === "plan_10_01" ? (A = true) : false;
            });
            this.codeType = A;
          }
        }, this)
        .catch(err =>
          console.log("ProjectsService.getDocumentESProjects: ", err)
        );
    },
    loadStatusHistory() {
      this.$store.dispatch(FETCH_PROJECT_HISTORY).then(() => {
        this.showStatusHistory = true;
        this.modalIsOpened = true;
      });
    },
    loadEAHistory() {
      ExpertAdvice.getHistoryProjectAdvice(this.project.ID).then(({ data }) => {
        this.eaHists = data.items;
        this.showEAHistory = true;
        this.modalIsOpened = true;
      });
    },
    exportEAHistory() {
      ExpertAdvice.getLinkReestrHistoryProjectAdviceExcel(this.project.ID).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    getLinkIndicatorsByOrgExcel() {
      ProjectsService.getLinkIndicatorsByOrgExcel(this.excelOrgId).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    getLinkPdfUrl() {
      ProjectsService.getPrintPDFUrl(this.project.ID).then(({ data }) => {
        /*window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;*/
        window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );
      });
    },
    getPlanLinkPdfUrl() {
      ProjectsService.getPlanPrintPDFUrl(this.project.ID).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      });
    },
    getLinkTemplateConformityUrl() {
      ProjectsService.getLinkTemplateConformityUrl(this.project.ID).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    getLinkTemplateMismatchUrl() {
      ProjectsService.getLinkTemplateMismatchUrl(this.project.ID).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    getStatusName: function(id) {
      let t = this.directory.status_all.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].NAME;
      }
    },
    getPrintPlanDocxUrl() {
      ProjectsService.getPrintPlanDocxUrl(this.project.ID).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      });
    }
  }
};
</script>

<style scoped></style>
